export default {"src":"/_next/static/media/gray-kitchen.22df6c8c.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};